"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mui = require("tss-react/mui");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Input = require("../Input");
var _withFormField = _interopRequireDefault(require("../hocs/withFormField"));
var _excluded = ["options", "handleChange", "size", "emptyValueLabel", "innerText", "multiple", "disabled", "helperText", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  return {
    root: {
      width: '100%',
      maxWidth: '100%',
      '& fieldset': {
        borderRadius: '5px 5px 0 0'
      }
    },
    select: {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5)
    },
    selectSmall: {
      paddingTop: theme.spacing(0.75),
      paddingBottom: theme.spacing(0.75)
    },
    endAdornment: {
      position: 'absolute',
      right: theme.spacing(2)
    }
  };
});
var SelectInput = function SelectInput(props) {
  var _completeOptions3;
  var selectValue = props.value,
    defaultValue = props.defaultValue;
  var _useState = (0, _react.useState)(selectValue ? undefined : defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    checkedItems = _useState2[0],
    setCheckedItems = _useState2[1];
  var options = props.options,
    handleChange = props.handleChange,
    size = props.size,
    emptyValueLabel = props.emptyValueLabel,
    innerText = props.innerText,
    multiple = props.multiple,
    disabled = props.disabled,
    helperText = props.helperText,
    className = props.className,
    other = _objectWithoutProperties(props, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var completeOptions = options;
  if (emptyValueLabel && !multiple) completeOptions = [{
    label: emptyValueLabel,
    value: ''
  }].concat(_toConsumableArray(options));
  var customRenderValue = function customRenderValue(selected) {
    var _completeOptions2;
    if (multiple) {
      if ((selected === null || selected === void 0 ? void 0 : selected.length) === 0) return emptyValueLabel;
      var multipleLabels = selected === null || selected === void 0 ? void 0 : selected.map(function (element) {
        var _completeOptions, _completeOptions$find;
        return (_completeOptions = completeOptions) === null || _completeOptions === void 0 ? void 0 : (_completeOptions$find = _completeOptions.find(function (_ref) {
          var value = _ref.value,
            label = _ref.label;
          return value === element || label === element;
        })) === null || _completeOptions$find === void 0 ? void 0 : _completeOptions$find.label;
      });
      var multipleRenderLabels = multipleLabels.join(', ');
      if (innerText === undefined) return multipleRenderLabels;
      return "".concat(innerText, " ").concat(multipleRenderLabels);
    }
    if (selected === '') return emptyValueLabel;
    var singleLabel = (_completeOptions2 = completeOptions) === null || _completeOptions2 === void 0 ? void 0 : _completeOptions2.find(function (_ref2) {
      var value = _ref2.value,
        label = _ref2.label;
      return value === selected || label === selected;
    });
    if (innerText !== undefined) return "".concat(innerText, " ").concat(singleLabel === null || singleLabel === void 0 ? void 0 : singleLabel.label, " ");
    return singleLabel === null || singleLabel === void 0 ? void 0 : singleLabel.label;
  };
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    classes: {
      root: cx(classes.root, className)
    }
  }, /*#__PURE__*/_react["default"].createElement(_Select["default"], _extends({
    classes: {
      select: size === 'small' ? classes.selectSmall : classes.select
    },
    displayEmpty: true,
    margin: "dense",
    multiple: multiple,
    value: checkedItems ? selectValue : checkedItems,
    renderValue: customRenderValue,
    disabled: disabled,
    input: /*#__PURE__*/_react["default"].createElement(_Input.InputBase, {
      handleChange: defaultValue ? setCheckedItems : handleChange
    })
  }, other), (_completeOptions3 = completeOptions) === null || _completeOptions3 === void 0 ? void 0 : _completeOptions3.map(function (_ref3) {
    var value = _ref3.value,
      label = _ref3.label,
      startAdornment = _ref3.startAdornment,
      endAdornment = _ref3.endAdornment;
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: value,
      value: value
    }, startAdornment && /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, startAdornment), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, multiple ? /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
      label: label,
      checked: selectValue ? (selectValue === null || selectValue === void 0 ? void 0 : selectValue.includes(value)) || false : (checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems.includes(value)) || false,
      control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        color: "primary"
      })
    }) : label), endAdornment && /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.endAdornment
    }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, null, endAdornment)));
  })));
};
SelectInput.propTypes = {
  helperText: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  emptyValueLabel: _propTypes["default"].string,
  className: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['small', 'normal']),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number), _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number), _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  handleChange: _propTypes["default"].func,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    startAdornment: _propTypes["default"].node,
    endAdornment: _propTypes["default"].node
  })).isRequired,
  innerText: _propTypes["default"].string
};
SelectInput.defaultProps = {
  value: undefined,
  defaultValue: undefined,
  handleChange: undefined,
  helperText: undefined,
  emptyValueLabel: undefined,
  className: undefined,
  size: 'normal',
  multiple: undefined,
  disabled: undefined,
  innerText: undefined
};
var _default = (0, _withFormField["default"])({
  messagePosition: 'bottom'
})(SelectInput);
exports["default"] = _default;